module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#rss",
      toString: function () {
        return this.url;
      }
    }